import { breakpointDown, getThemeColor } from '@sparemin/blockhead';
import InfoCard from 'components/InfoCard';
import styled from 'styled-components';

type CardStyleProps = {
  $isDisabled?: boolean;
};

export const Root = styled.div`
  width: 100%;
  display: flex;
  gap: 40px;

  ${breakpointDown('md')`
    flex-direction: column;
    gap: 20px;
  `}
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 12px;
  padding: 0 24px;
  padding-bottom: 24px;
`;

export const Card = styled(InfoCard)<CardStyleProps>`
  width: 100%;
  height: 345px;
  position: relative;
  border-width: 2px;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
      border-color: #f6f6f6;
      pointer-events: none;

      &::after {
        content: '';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(255, 255, 255, 0.7);
      }

      ${ButtonContainer} {
        position: relative;
        z-index: 1;
      }
    `}
`;

export const CardContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
`;

export const HeadlinerCardContainer = styled(CardContainer)`
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.25),
      rgba(255, 255, 255, 0.25)
    ),
    linear-gradient(117deg, rgb(93, 190, 252), rgb(221, 146, 254));
`;

export const PublisherCardContainer = styled(CardContainer)`
  background-color: ${getThemeColor('l3')};
`;

export const YoutubeCardContainer = styled(CardContainer)`
  background-color: ${getThemeColor('l3')};
`;

export const YoutubeLogoTile = styled.div`
  width: 96px;
  height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background-color: white;
`;
